// Types for company and market data
export interface MockCompany {
  id: string;
  name: string;
  symbol: string;
  sector: string;
  description: string;
  marketCap: string;
  peRatio: number;
  dividendYield: number;
  volatility: number; // 1-5 scale, affects price movements
  riskLevel: number; // 1-5 scale
  potentialReward: number; // 1-5 scale
  analystRating: string;
}

// Mock company data with realistic market information
export const mockCompanies: MockCompany[] = [
  {
    id: "1",
    name: "GreenTech Solutions",
    symbol: "GTS",
    sector: "Technology",
    description: "Leading provider of sustainable technology solutions with strong growth potential but moderate market volatility",
    marketCap: "$5.2B",
    peRatio: 22.5,
    dividendYield: 1.8,
    volatility: 3,
    riskLevel: 2,
    potentialReward: 4,
    analystRating: "Buy"
  },
  {
    id: "2",
    name: "EcoEnergy Corp",
    symbol: "ECO",
    sector: "Energy",
    description: "Stable renewable energy company with consistent dividends and lower volatility",
    marketCap: "$3.8B",
    peRatio: 18.3,
    dividendYield: 2.5,
    volatility: 2,
    riskLevel: 1,
    potentialReward: 2,
    analystRating: "Hold"
  },
  {
    id: "3",
    name: "HealthTech Innovations",
    symbol: "HTI",
    sector: "Healthcare",
    description: "High-growth healthcare technology company with higher risk but significant upside potential",
    marketCap: "$2.9B",
    peRatio: 25.7,
    dividendYield: 1.2,
    volatility: 4,
    riskLevel: 4,
    potentialReward: 5,
    analystRating: "Strong Buy"
  },
  {
    id: "4",
    name: "SmartFinance",
    symbol: "SFI",
    sector: "Financial Services",
    description: "Established fintech company with moderate risk and steady returns",
    marketCap: "$4.1B",
    peRatio: 16.8,
    dividendYield: 3.1,
    volatility: 2,
    riskLevel: 2,
    potentialReward: 3,
    analystRating: "Buy"
  },
  {
    id: "5",
    name: "DataSecure Systems",
    symbol: "DSS",
    sector: "Cybersecurity",
    description: "Emerging cybersecurity leader with high growth potential but significant market volatility",
    marketCap: "$3.5B",
    peRatio: 28.4,
    dividendYield: 0.9,
    volatility: 5,
    riskLevel: 5,
    potentialReward: 5,
    analystRating: "Strong Buy"
  }
];

// Helper function to get risk level description
export const getRiskLevelDescription = (level: number): string => {
  switch (level) {
    case 1: return "Very Low - Minimal risk, suitable for conservative investors";
    case 2: return "Low - Below average risk, good for balanced portfolios";
    case 3: return "Moderate - Average market risk level";
    case 4: return "High - Above average risk, suitable for growth investors";
    case 5: return "Very High - Significant risk, for aggressive investors only";
    default: return "Unknown risk level";
  }
};

// Helper function to get reward potential description
export const getRewardDescription = (level: number): string => {
  switch (level) {
    case 1: return "Very Low - Limited upside potential";
    case 2: return "Low - Modest growth expectations";
    case 3: return "Moderate - Average growth potential";
    case 4: return "High - Strong growth potential";
    case 5: return "Very High - Exceptional growth potential";
    default: return "Unknown reward potential";
  }
};

// Helper function to get volatility description
export const getVolatilityDescription = (level: number): string => {
  switch (level) {
    case 1: return "Very Low - Price remains relatively stable";
    case 2: return "Low - Minor price fluctuations";
    case 3: return "Moderate - Average price movements";
    case 4: return "High - Significant price swings";
    case 5: return "Very High - Extreme price movements";
    default: return "Unknown volatility level";
  }
};